export default "__VITE_ASSET__T$ff0cfd__"